module.exports = __webpack_public_path__ + "static/media/card-profile1-square.7a6bc100.jpg";